import { atom } from 'jotai';
import { Classroom } from '@teetsh/app/src/types/classroom';
import { CJEvent } from 'types/event';

export const creatorCJSeancePayloadAtom = atom<
  | {
      seance: Omit<CJEvent, 'id'>;
      classrooms: Classroom[];
    }
  | undefined
>(undefined);
